"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfShiftViewsByProfileDto = instanceOfShiftViewsByProfileDto;
exports.ShiftViewsByProfileDtoFromJSON = ShiftViewsByProfileDtoFromJSON;
exports.ShiftViewsByProfileDtoFromJSONTyped = ShiftViewsByProfileDtoFromJSONTyped;
exports.ShiftViewsByProfileDtoToJSON = ShiftViewsByProfileDtoToJSON;
exports.ShiftViewsByProfileDtoToJSONTyped = ShiftViewsByProfileDtoToJSONTyped;
const ShiftViewDto_1 = require("./ShiftViewDto");
/**
 * Check if a given object implements the ShiftViewsByProfileDto interface.
 */
function instanceOfShiftViewsByProfileDto(value) {
    if (!('profileId' in value) || value['profileId'] === undefined)
        return false;
    if (!('views' in value) || value['views'] === undefined)
        return false;
    return true;
}
function ShiftViewsByProfileDtoFromJSON(json) {
    return ShiftViewsByProfileDtoFromJSONTyped(json, false);
}
function ShiftViewsByProfileDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'profileId': json['profileId'],
        'views': (json['views'].map(ShiftViewDto_1.ShiftViewDtoFromJSON)),
    };
}
function ShiftViewsByProfileDtoToJSON(json) {
    return ShiftViewsByProfileDtoToJSONTyped(json, false);
}
function ShiftViewsByProfileDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'profileId': value['profileId'],
        'views': (value['views'].map(ShiftViewDto_1.ShiftViewDtoToJSON)),
    };
}
//# sourceMappingURL=ShiftViewsByProfileDto.js.map